"use client";

interface SelectFieldProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  hint?: string;
  id: string;
  options: { value: string | number; label: string }[];
}

export default function SelectField({
  label,
  hint,
  id,
  options,
  className = "",
  ...props
}: SelectFieldProps) {
  return (
    <div className="flex flex-col gap-1.5 w-full">
      <label
        htmlFor={id}
        className="text-[10px] font-bold tracking-[0.08em] uppercase text-slate-500 dark:text-slate-400 select-none"
      >
        {label}
      </label>
      <div className="relative flex items-center w-full">
        <select
          id={id}
          className={`flex h-12 w-full rounded-lg border pl-3 pr-10 py-2 text-sm bg-white dark:bg-slate-700 text-slate-900 dark:text-slate-50 border-slate-200 dark:border-slate-800 transition-colors focus:outline-none focus:ring-1 focus:ring-accent focus:border-accent appearance-none cursor-pointer ${className}`}
          {...props}
        >
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        {/* Custom Chevron Arrow Overlay */}
        <div className="absolute right-3 pointer-events-none select-none text-slate-400 dark:text-slate-500">
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
      {hint && (
        <p className="text-xs text-slate-450 dark:text-slate-500 font-medium">
          {hint}
        </p>
      )}
    </div>
  );
}
